import React, { useEffect, useState } from 'react';
import { siigoListDocs, siigoGetDocPdfBlob } from '../services/api';

const fmt = (n) => new Intl.NumberFormat('es-CO', { style:'currency', currency:'COP', minimumFractionDigits:0 }).format(n || 0);

/** Lista paginada de documentos históricos importados de Siigo (facturas | cotizaciones). */
export default function HistorialSiigo({ tipo, clienteNit }) {
  const [hist, setHist] = useState(null);
  const [loading, setLoading] = useState(false);

  const cargar = async (page = 1) => {
    setLoading(true);
    try { const { data } = await siigoListDocs(tipo, page, clienteNit); setHist(data); }
    catch { setHist(null); }
    finally { setLoading(false); }
  };
  useEffect(() => { cargar(1); /* eslint-disable-next-line */ }, [tipo, clienteNit]);

  const verDoc = async (d) => {
    if (!d.pdf_path && d.public_url) { window.open(d.public_url, '_blank'); return; }
    try { const r = await siigoGetDocPdfBlob(d.id); window.open(URL.createObjectURL(r.data), '_blank'); }
    catch { alert('No se pudo abrir el documento'); }
  };

  const totalPag = hist ? Math.ceil(hist.total / 50) : 1;

  return (
    <div style={s.card}>
      <div style={s.head}>
        <p style={s.info}>
          📄 Documentos históricos importados desde Siigo
          {hist ? ` · ${hist.total} ${tipo === 'factura' ? 'facturas' : 'cotizaciones'}` : ''}
        </p>
      </div>
      {loading && <p style={s.hint}>Cargando…</p>}
      {hist && (
        <div style={{ overflowX:'auto' }}>
          <table style={s.table}>
            <thead>
              <tr>{['Número','Fecha','Cliente','Total',''].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {hist.documentos.map(d => (
                <tr key={d.id} style={s.tr}>
                  <td style={{ ...s.td, color:'#f1f5f9', fontWeight:500 }}>{d.prefijo || ''}{d.numero}</td>
                  <td style={s.td}>{d.fecha || '—'}</td>
                  <td style={{ ...s.td, maxWidth:320, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{d.cliente || '—'}</td>
                  <td style={s.td}>{fmt(d.total)}</td>
                  <td style={s.td}>
                    <button style={s.btnVer} onClick={() => verDoc(d)}>{d.pdf_path ? 'Ver PDF' : 'Ver en Siigo ↗'}</button>
                  </td>
                </tr>
              ))}
              {hist.documentos.length === 0 &&
                <tr><td colSpan={5} style={{ ...s.td, textAlign:'center', padding:24, color:'#64748b' }}>
                  No hay documentos históricos importados. Importalos en Importar → Desde Siigo.
                </td></tr>}
            </tbody>
          </table>
          {hist.total > 50 && (
            <div style={s.pager}>
              <button style={s.btnVer} disabled={hist.page <= 1} onClick={() => cargar(hist.page - 1)}>← Anterior</button>
              <span style={s.hint}>Página {hist.page} de {totalPag}</span>
              <button style={s.btnVer} disabled={hist.page >= totalPag} onClick={() => cargar(hist.page + 1)}>Siguiente →</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const s = {
  card: { background:'#1e293b', borderRadius:12, border:'1px solid #334155', padding:20 },
  head: { marginBottom:12 },
  info: { color:'#94a3b8', fontSize:13, margin:0 },
  table: { width:'100%', borderCollapse:'collapse', fontSize:13 },
  th: { color:'#64748b', fontSize:11, fontWeight:600, textAlign:'left', padding:'0 10px 10px', textTransform:'uppercase' },
  tr: { borderTop:'1px solid #334155' },
  td: { padding:'4px 10px', color:'#94a3b8' },
  btnVer: { background:'#0f172a', border:'1px solid #334155', color:'#7dd3fc', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' },
  pager: { display:'flex', alignItems:'center', justifyContent:'center', gap:16, marginTop:14 },
  hint: { color:'#475569', fontSize:12 },
};
